"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateBanner = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var usePermissionObject_1 = require("./usePermissionObject");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var Icon_1 = require("../Icon");
var usePermissionDisplayMode_1 = require("./usePermissionDisplayMode");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var PrivacyStatusConfirmation_1 = require("./PrivacyStatusConfirmation");
var PrivateBanner = function () {
    var _a = (0, usePermissionsModalContext_1.usePermissionsModalContext)(), _js = _a._js, usePermissions = _a.usePermissions, useSetPrivacyStatus = _a.useSetPrivacyStatus;
    var _b = (0, usePermissionObject_1.usePermissionObject)(), objectType = _b.objectType, objectId = _b.objectId;
    var mode = (0, usePermissionDisplayMode_1.usePermissionDisplayMode)();
    var permissions = usePermissions(objectType, objectId).data;
    var _c = (0, react_1.useDisclosure)(), isOpen = _c.isOpen, onOpen = _c.onOpen, onClose = _c.onClose;
    var privacyStatusMutation = useSetPrivacyStatus(objectType, objectId, {
        onSuccess: onClose,
        onError: onClose,
    });
    var bannerTitles = {
        courseGroups: _js('This is a private course group'),
        manageSections: _js('This is a private page'),
        guides: _js('This is a private guide'),
        wikis: _js('This is a private wiki'),
        workspaces: _js('This is a private workspace'),
    };
    var bannerDescriptions = {
        courseGroups: _js('Only users & teams listed below have access to content in this course group'),
        manageSections: _js('Only users & teams listed below have access to content in this page'),
        guides: _js('Only users & teams listed below have access to content in this guide'),
        wikis: _js('Only users & teams listed below have access to content in this wiki'),
        workspaces: _js('Only users & teams listed below have access to content in this workspace'),
    };
    var confirmationMessages = {
        courseGroups: _js('This will immediately allow all teams and users on this site to view the content in this course group.'),
        manageSections: _js('This will immediately allow all teams and users on this site to view the content in this page.'),
        guides: _js('This will immediately allow all teams and users on this site to view the content in this guide.'),
        wikis: _js('This will immediately allow all teams and users on this site to view the content in this wiki.'),
        workspaces: _js('This will immediately allow all teams and users on this site to view the content in this workspace.'),
    };
    if ((permissions === null || permissions === void 0 ? void 0 : permissions.privacyStatus) !== 'private') {
        return null;
    }
    return (React.createElement(react_1.Flex, { backgroundColor: "gray.50", borderRadius: "lg", p: 3, mt: 1, mb: 3, direction: { base: 'column', sm: 'row' }, "data-testid": "permissions-modal-private-banner" },
        React.createElement(react_1.Flex, { direction: "column" },
            React.createElement(react_1.Box, { mb: 2 },
                React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faWarning, color: "yellow.700", size: 'xl' }),
                React.createElement(react_1.Text, { as: "span", fontSize: "md", mx: 2, color: "black" }, bannerTitles[objectType]),
                React.createElement(react_1.Tag, { backgroundColor: "yellow.300", fontSize: "13px", fontWeight: "600", verticalAlign: "center", color: "black" }, _js('Private'))),
            React.createElement(react_1.Text, { fontSize: "md", fontWeight: "400", color: "gray.700", m: 0 }, bannerDescriptions[objectType])),
        mode === 'edit' && (React.createElement(React.Fragment, null,
            React.createElement(react_1.Flex, { align: { base: 'auto', sm: 'center' }, mt: { base: 3, sm: 0 }, ml: { base: 0, sm: 3 } },
                React.createElement(react_1.Button, { fontSize: { base: 'sm', sm: 'md' }, color: "gray.800", "data-testid": "private-banner-make-public-button", onClick: onOpen }, _js('Give Access to Everyone'))),
            React.createElement(PrivacyStatusConfirmation_1.PrivacyStatusConfirmation, { isOpen: isOpen, onClose: onClose, privacyStatusMutation: privacyStatusMutation, newPrivacyStatus: "public", topIcon: pro_solid_svg_icons_1.faUnlock, headingText: _js('Give Access to Everyone?'), message: confirmationMessages[objectType], confirmButtonOptions: {
                    icon: pro_regular_svg_icons_1.faBuilding,
                    text: _js('Give Access to Everyone'),
                } })))));
};
exports.PrivateBanner = PrivateBanner;
